import { render, staticRenderFns } from "./InsPage.vue?vue&type=template&id=4317f4b4&scoped=true&"
import script from "./InsPage.vue?vue&type=script&lang=js&"
export * from "./InsPage.vue?vue&type=script&lang=js&"
import style0 from "./InsPage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./InsPage.vue?vue&type=style&index=1&id=4317f4b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4317f4b4",
  null
  
)

export default component.exports